import { render } from "./AddGeneral.vue?vue&type=template&id=ebe08276&scoped=true"
import script from "./AddGeneral.vue?vue&type=script&lang=js"
export * from "./AddGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe08276"]])

export default __exports__